import ManagePhotos from '@/App/Settings/Photos/ManagePhotos.vue';

export default ManagePhotos;
